<script lang="ts">
  import { ChevronDown } from '@lucide/svelte'
  import useAuth, { useCurrentUser } from '../../queries/auth'
  import {
    DropdownContainer,
    DropdownTrigger,
    DropdownContent,
    DropdownItem,
  } from '../dropdown'
  import UserAvatar from '../user-avatar/UserAvatar.svelte'
  import i18n from '../../i18n'

  const { signoutMutation } = useAuth()
  const userQuery = useCurrentUser()
</script>

<div class="user-menu-container">
  <DropdownContainer>
    <DropdownTrigger>
      <div class="user-infos">
        <div class="username">
          {userQuery.data?.data.username}
        </div>
        <UserAvatar name={userQuery.data?.data.username || ''} size={32} />
        <ChevronDown color="var(--icon-button-foreground)" size=".75rem" />
      </div>
    </DropdownTrigger>
    <DropdownContent placement="bottom-end">
      <DropdownItem href="/projects">
        {$i18n.t('navbar.dropdown.backToProjects')}
      </DropdownItem>
      <DropdownItem href={import.meta.env.VITE_OAUTH_URL}>
        {$i18n.t('navbar.dropdown.settings')}
      </DropdownItem>
      <DropdownItem
        onclick={() => signoutMutation.mutate()}
        variant="destructive"
      >
        {$i18n.t('navbar.dropdown.signout')}
      </DropdownItem>
    </DropdownContent>
  </DropdownContainer>
</div>

<style lang="scss">
  .user-menu-container {
    display: flex;
    justify-content: flex-end;
    transition: all 0.3s ease;
    height: 100%;
    width: 100%;
    padding-right: 0.5rem;
    padding-left: 1.5rem;

    .user-infos {
      width: 100%;
      align-self: stretch;
      align-items: center;
      display: flex;
      flex-direction: row;
      gap: 0.25rem;

      .username {
        margin-right: 0.5rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
</style>
